
export class BitArray {
	private static FullByte = 0xFF;

	private static ByteFlags = [
		0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80
	];

	private _bits: Uint8Array;
	private _length: number;
	public get Length(): number {
		return this._length;
	}

	public set Length(val: number) {
		this.Length = val;
		var neededBlocks = this.neededBlocks(val);
		this._SizeArray(neededBlocks);
	}

	constructor(other?: Uint8Array) {
		if (other) {
			this._bits = new Uint8Array(other.length);

			for (var i = 0; i < other.length; i++) {
				this._bits[i] = other[0];
			}
			this._length = this._bits.length * 8;
		} else {
			this._bits = new Uint8Array(0);
		}
	}

	private neededBlocks(bit: number) {
		return ((length + 8 - 1) / 8);
	}

	private blockIndex(bit: number) {
		return bit / 8;
	}

	private byteIndex(bit: number) {
		return bit % 8;
	}

	private _SizeArray(blocks: number) {
		var newArray = new Uint8Array(blocks);

		for (var i = Math.min(newArray.length, this._bits.length) - 1; i >= 0; i--) {
			newArray[i] = this._bits[i];
		}

		this._bits = newArray;
	}

	public SetAll(state: boolean) {
		var val = state ? BitArray.FullByte : 0;

		for (var i = this._bits.length - 1; i >= 0; i--)
			this._bits[i] = val;
	}

	public Set(index: number, state: boolean) :boolean {
		if (index > this.Length)
			return false;

		if (state)
			this._bits[this.blockIndex(index)] |= BitArray.ByteFlags[this.byteIndex[index]];
		else
			this._bits[this.blockIndex(index)] &= ~BitArray.ByteFlags[this.byteIndex[index]];

		return true;
	}

	public Get(index: number): boolean {
		if (index > this.Length)
			return null;

		return this._bits[this.blockIndex(index)] & BitArray.ByteFlags[this.byteIndex[index]]?true:false;
	}

	public ToByteArray(): Uint8Array {
		var result = new Uint8Array(this._bits.length);

		for (var i = 0; i < this._bits.length; i++) {
			result[i] = this._bits[i];
		};

		return result;
	}

}
